import React from "react";
import { Link } from "react-router-dom";

export const memberEnquiryColumns = ( PAGE_SIZE) => [
  {
    label: "S.No",
    width: 30,
    render: (row, index, page) =>
      (page - 1) * PAGE_SIZE + index + 1,
  },

  {
    label: "Perfect Search",
    width: 100,
    render: (row) => (
      <div className="userdet">
        {row?.create_profile?.name}
      </div>
    ),
  },

  {
    label: "Name",
    width: 220,
    render: (row) => <span>
        {row.name}</span>,
  },

  {
    label: "Mobile",
    width: 120,
    render: (row) => (
      <>
        {row.mobile}
      </>
    ),
  },
  {
    label: "Date",
    width: 120,
    render: (row) => (
      <>
         {(() => {
            const d = new Date(row.createdAt);
            return `${d.getDate().toString().padStart(2, '0')}-${(d.getMonth()+1).toString().padStart(2, '0')}-${d.getFullYear()}`;
        })()}
      </>
    ),
  },

  
];
